module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/jszip/node_modules/core-js/library/modules/_fails.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_fails.js
// module chunks = vendor